import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NAV_TYPE_TOP } from 'constants/ThemeConstant';
import utils from 'utils';
import MenuContent from './MenuContent';

export const TopNav = ({ topNavColor, localization = true, menuId }) => {
  const props = { topNavColor, localization };
  return (
    <div
      className={`top-nav ${utils.getColorContrast(topNavColor)}`}
      style={{ backgroundColor: topNavColor }}>
      <div className="top-nav-wrapper">
        <MenuContent type={NAV_TYPE_TOP} {...props} menuId={menuId} />
      </div>
    </div>
  );
};

TopNav.propTypes = {
  topNavColor: PropTypes.string,
  localization: PropTypes.bool,
  menuId: PropTypes.number,
};

const mapStateToProps = ({ theme }) => {
  const { topNavColor } = theme;
  return { topNavColor };
};

export default connect(mapStateToProps)(TopNav);
